import React from 'react';

import { newOperationModel } from 'forms/newOperation';
import DoubleLeftLabelTextField from 'components/Fields/DoubleLeftLabelTextField';
import TwoColumnField from 'components/Fields/TwoColumnField';

const {
  stepTwo: {
    batchNumber,
    batchDescription,
    branchOffice,
    branchAddress,
    cardType,
    closing,
    creditLimit,
    financingLimit,
    installmentsLimit,
    advancementLimit,
    paymentMethod,
    contractDate,
    place,
    bcraCode,
    igSituacionCode,
    ivaSituation,
    ivaExtent,
    reason
  },
} = newOperationModel;

function StepTwo({ formProps, readOnly, ...rest }) {
  return (
    <fieldset disabled={readOnly} style={{ border: 0 }}>
      <DoubleLeftLabelTextField left={batchNumber} right={batchDescription} />
      <TwoColumnField left={branchOffice} right={branchAddress} />
      <TwoColumnField left={creditLimit} right={paymentMethod} />
      <TwoColumnField left={cardType} right={closing} />
      <DoubleLeftLabelTextField left={advancementLimit} right={reason}/>
      <DoubleLeftLabelTextField left={financingLimit} right={installmentsLimit} />
      <DoubleLeftLabelTextField left={contractDate} right={place} />
      <DoubleLeftLabelTextField left={bcraCode} right={igSituacionCode} />
      <DoubleLeftLabelTextField left={ivaSituation} right={ivaExtent} />
    </fieldset>
  );
}

export default StepTwo;
